export default {
  methods: {
    mapLayerSnowmakingAirwatergunsAdd() {
      this.initPollSnowmakingAirwaterguns();

      this.map.addSource("airwaterguns", {
        type: "geojson",
        data: this.computedSnowmakingAirwatergunsGeoJson
      });

      // Class 1001
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/1001.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-1001", image);

          this.map.addLayer({
            id: "airwaterguns-1001",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 1001]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-1001",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-1001", "marker-layer-points");
        }
      );

      // Class 1002
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/1002.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-1002", image);

          this.map.addLayer({
            id: "airwaterguns-1002",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 1002]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-1002",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-1002", "marker-layer-points");
        }
      );

      // Class 1003
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/1003.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-1003", image);

          this.map.addLayer({
            id: "airwaterguns-1003",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 1003]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-1003",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-1003", "marker-layer-points");
        }
      );

      // Class 1005
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/1005.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-1005", image);

          this.map.addLayer({
            id: "airwaterguns-1005",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 1005]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-1005",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-1005", "marker-layer-points");
        }
      );

      // Class 1006
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/1006.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-1006", image);

          this.map.addLayer({
            id: "airwaterguns-1006",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 1006]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-1006",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-1006", "marker-layer-points");
        }
      );

      // Class 1007
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/1007.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-1007", image);

          this.map.addLayer({
            id: "airwaterguns-1007",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 1007]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-1007",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-1007", "marker-layer-points");
        }
      );

      // Class 1008
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/1008.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-1008", image);

          this.map.addLayer({
            id: "airwaterguns-1008",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 1008]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-1008",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-1008", "marker-layer-points");
        }
      );

      // Class 1012
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/1012.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-1012", image);

          this.map.addLayer({
            id: "airwaterguns-1012",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 1012]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-1012",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-1012", "marker-layer-points");
        }
      );

      // Class 1014
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/1014.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-1014", image);

          this.map.addLayer({
            id: "airwaterguns-1014",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 1014]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-1014",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-1014", "marker-layer-points");
        }
      );

      // Class 1016
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/1016.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-1016", image);

          this.map.addLayer({
            id: "airwaterguns-1016",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 1016]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-1016",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-1016", "marker-layer-points");
        }
      );

      // Class 2003
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/2003.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-2003", image);

          this.map.addLayer({
            id: "airwaterguns-2003",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 2003]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-2003",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-2003", "marker-layer-points");
        }
      );

      // Class 2007
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/2007.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-2007", image);

          this.map.addLayer({
            id: "airwaterguns-2007",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 2007]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-2007",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-2007", "marker-layer-points");
        }
      );

      // Class 2008
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/2008.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-2008", image);

          this.map.addLayer({
            id: "airwaterguns-2008",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 2008]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-2008",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-2008", "marker-layer-points");
        }
      );

      // Class 2009
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/2009.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-2009", image);

          this.map.addLayer({
            id: "airwaterguns-2009",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 2009]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-2009",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-2009", "marker-layer-points");
        }
      );

      // Class 2010
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/2010.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-2010", image);

          this.map.addLayer({
            id: "airwaterguns-2010",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 2010]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-2010",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-2010", "marker-layer-points");
        }
      );

      // Class 2011
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/2011.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-2011", image);

          this.map.addLayer({
            id: "airwaterguns-2011",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 2011]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-2011",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-2011", "marker-layer-points");
        }
      );

      // Class 2013
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/2013.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-2013", image);

          this.map.addLayer({
            id: "airwaterguns-2013",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 2013]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-2013",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-2013", "marker-layer-points");
        }
      );
      // Class 3003
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/3003.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-3003", image);

          this.map.addLayer({
            id: "airwaterguns-3003",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 3003]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-3003",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-3003", "marker-layer-points");
        }
      );
      // Class 3004
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/3004.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-3004", image);

          this.map.addLayer({
            id: "airwaterguns-3004",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 3004]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-3004",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-3004", "marker-layer-points");
        }
      );
      // Class 3005
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/3005.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-3005", image);

          this.map.addLayer({
            id: "airwaterguns-3005",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 3005]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-3005",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-3005", "marker-layer-points");
        }
      );
      // Class 3006
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/3006.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-3006", image);

          this.map.addLayer({
            id: "airwaterguns-3006",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 3006]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-3006",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-3006", "marker-layer-points");
        }
      );
      // Class 3008
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/3008.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-3008", image);

          this.map.addLayer({
            id: "airwaterguns-3008",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 3008]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-3008",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-3008", "marker-layer-points");
        }
      );
      // Class 3009
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/3009.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-3009", image);

          this.map.addLayer({
            id: "airwaterguns-3009",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 3009]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-3009",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-3009", "marker-layer-points");
        }
      );
      // Class 3011
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/3011.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-3011", image);

          this.map.addLayer({
            id: "airwaterguns-3011",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 3011]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-3011",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-3011", "marker-layer-points");
        }
      );
      // Class 3012
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/3012.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-3012", image);

          this.map.addLayer({
            id: "airwaterguns-3012",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 3012]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-3012",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-3012", "marker-layer-points");
        }
      );
      // Class 3013
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/3013.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-3013", image);

          this.map.addLayer({
            id: "airwaterguns-3013",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 3013]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-3013",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-3013", "marker-layer-points");
        }
      );
      // Class 3014
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/3014.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-3014", image);

          this.map.addLayer({
            id: "airwaterguns-3014",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 3014]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-3014",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-3014", "marker-layer-points");
        }
      );
      // Class 3015
      this.map.loadImage(
        "https://storage.googleapis.com/map-tiles-wbsnow/icons/snowmaking/airwaterguns/3015.png",
        (error, image) => {
          this.map.addImage("icon-snowmaking-airwaterguns-3015", image);

          this.map.addLayer({
            id: "airwaterguns-3015",
            filter: [
              "all",
              ["!=", "status", "Retired"],
              ["!=", "status", "Inactive"],
              ["==", "class", 3015]
            ],
            type: "symbol",
            source: "airwaterguns",
            layout: {
              "icon-image": "icon-snowmaking-airwaterguns-3015",
              "icon-size": 0.5,
              "icon-offset": [-35, 0],
              "icon-allow-overlap": true
            }
          });
          this.map.moveLayer("airwaterguns-3015", "marker-layer-points");
        }
      );
    },
    // method to remove all layers and the source
    mapLayerSnowmakingAirwatergunsRemove() {
      this.cancelPollSnowmakingAirwaterguns();
      this.map.removeImage("icon-snowmaking-airwaterguns-1002");
      this.map.removeImage("icon-snowmaking-airwaterguns-1001");
      this.map.removeImage("icon-snowmaking-airwaterguns-1003");
      this.map.removeImage("icon-snowmaking-airwaterguns-1005");
      this.map.removeImage("icon-snowmaking-airwaterguns-1006");
      this.map.removeImage("icon-snowmaking-airwaterguns-1007");
      this.map.removeImage("icon-snowmaking-airwaterguns-1008");
      this.map.removeImage("icon-snowmaking-airwaterguns-1012");
      this.map.removeImage("icon-snowmaking-airwaterguns-1014");
      this.map.removeImage("icon-snowmaking-airwaterguns-1016");
      this.map.removeImage("icon-snowmaking-airwaterguns-2003");
      this.map.removeImage("icon-snowmaking-airwaterguns-2007");
      this.map.removeImage("icon-snowmaking-airwaterguns-2008");
      this.map.removeImage("icon-snowmaking-airwaterguns-2009");
      this.map.removeImage("icon-snowmaking-airwaterguns-2010");
      this.map.removeImage("icon-snowmaking-airwaterguns-2011");
      this.map.removeImage("icon-snowmaking-airwaterguns-2013");
      this.map.removeImage("icon-snowmaking-airwaterguns-3003");
      this.map.removeImage("icon-snowmaking-airwaterguns-3004");
      this.map.removeImage("icon-snowmaking-airwaterguns-3005");
      this.map.removeImage("icon-snowmaking-airwaterguns-3006");
      this.map.removeImage("icon-snowmaking-airwaterguns-3008");
      this.map.removeImage("icon-snowmaking-airwaterguns-3009");
      this.map.removeImage("icon-snowmaking-airwaterguns-3011");
      this.map.removeImage("icon-snowmaking-airwaterguns-3012");
      this.map.removeImage("icon-snowmaking-airwaterguns-3013");
      this.map.removeImage("icon-snowmaking-airwaterguns-3014");
      this.map.removeImage("icon-snowmaking-airwaterguns-3015");
      this.map.removeLayer("airwaterguns-1001");
      this.map.removeLayer("airwaterguns-1002");
      this.map.removeLayer("airwaterguns-1003");
      this.map.removeLayer("airwaterguns-1005");
      this.map.removeLayer("airwaterguns-1006");
      this.map.removeLayer("airwaterguns-1007");
      this.map.removeLayer("airwaterguns-1008");
      this.map.removeLayer("airwaterguns-1012");
      this.map.removeLayer("airwaterguns-1014");
      this.map.removeLayer("airwaterguns-1016");
      this.map.removeLayer("airwaterguns-2003");
      this.map.removeLayer("airwaterguns-2007");
      this.map.removeLayer("airwaterguns-2008");
      this.map.removeLayer("airwaterguns-2009");
      this.map.removeLayer("airwaterguns-2010");
      this.map.removeLayer("airwaterguns-2011");
      this.map.removeLayer("airwaterguns-2013");
      this.map.removeLayer("airwaterguns-3003");
      this.map.removeLayer("airwaterguns-3004");
      this.map.removeLayer("airwaterguns-3005");
      this.map.removeLayer("airwaterguns-3006");
      this.map.removeLayer("airwaterguns-3008");
      this.map.removeLayer("airwaterguns-3009");
      this.map.removeLayer("airwaterguns-3011");
      this.map.removeLayer("airwaterguns-3012");
      this.map.removeLayer("airwaterguns-3013");
      this.map.removeLayer("airwaterguns-3014");
      this.map.removeLayer("airwaterguns-3015");
      this.map.removeSource("airwaterguns");
    },
    // method to create the geojson polling
    initPollSnowmakingAirwaterguns() {
      this.$store.dispatch("actionGetGeoJson", {
        url:
          "https://api2.alchemymapping.com/vail/whistler/snowmaking/airwaterguns",
        dept: "snowmaking",
        layer: "airwaterguns",
        token: this.computedAuthToken
      });
      this.pollSnowmakingAirwatergunsInterval = setInterval(() => {
        this.$store.dispatch("actionGetGeoJson", {
          url:
            "https://api2.alchemymapping.com/vail/whistler/snowmaking/airwaterguns",
          dept: "snowmaking",
          layer: "airwaterguns",
          token: this.computedAuthToken
        });
      }, this.computedInterval);
    },
    // method to cancel poll
    cancelPollSnowmakingAirwaterguns() {
      this.pollSnowmakingAirwatergunsInterval = clearInterval(
        this.pollSnowmakingAirwatergunsInterval
      );
    }
  },
  computed: {
    computedAuthToken() {
      return this.$store.state.auth.token;
    },
    // the geojson
    computedSnowmakingAirwatergunsGeoJson() {
      return this.$store.state.mapLayers.snowmaking.layers.airwaterguns.geojson;
    },
    // visibility
    computedSnowmakingAirwatergunsMapVisibility() {
      return this.$store.state.mapLayers.snowmaking.layers.airwaterguns
        .visibility.mapView;
    },
    // grabs the interval from the vuex state
    computedInterval() {
      return this.$store.state.general.interval;
    },
    computedSingleView() {
      return this.$store.state.mapLayers.snowmaking.layers.airwaterguns
        .visibility.singleView;
    }
  },
  watch: {
    // watches the vuex state and if geojson changes removes then re-adds layers/source
    "$store.state.mapLayers.snowmaking.layers.airwaterguns.geojson": {
      handler() {
        if (this.computedSnowmakingAirwatergunsMapVisibility) {
          this.mapLayerSnowmakingAirwatergunsRemove();
          this.mapLayerSnowmakingAirwatergunsAdd();
        }
      }
    },
    // watches the vuex state of visibility and adds or removes the layer/source
    "$store.state.mapLayers.snowmaking.layers.airwaterguns.visibility.mapView": function(
      newValue
    ) {
      if (newValue) {
        this.mapLayerSnowmakingAirwatergunsAdd();
      } else {
        this.mapLayerSnowmakingAirwatergunsRemove();
      }
    }
  },
  beforeDestroy() {
    // cancels poll on component destroy
    this.cancelPollSnowmakingAirwaterguns();
  }
};
